var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",null,null,{
			doSearch: _setup.doSearch,
			doSort: _setup.doSort,
			download: _setup.download,
			downloading: _setup.downloading,
			empty: _setup.empty,
			filters: _vm.filters,
			hasMultiplePages: _setup.hasMultiplePages,
			hasNextPage: _setup.hasNextPage,
			hasPrevPage: _setup.hasPrevPage,
			loading: _setup.loading,
			nextPage: _setup.nextPage,
			page: _setup.page,
			pages: _setup.pages,
			prevPage: _setup.prevPage,
			refresh: _setup.refresh,
			results: _setup.results,
			search: _vm.search,
			total: _setup.total,
		})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }